import React from 'react';
import { useAuth } from 'context/AuthContext';
import CONSTANTES_AMBIENTE from 'constants/constantesAmbiente';
import { contextoSemTenantComLinhaDeServico } from 'utils/contextos';

const LINHAS_DE_SERVICO_QUE_EXIGEM_TENANT = [
  CONSTANTES_AMBIENTE.LINHA_SERVICO.M365_GERENCIADO,
  CONSTANTES_AMBIENTE.LINHA_SERVICO.M365_BASICO
];

export default function TenantWarning() {
  const { contexto } = useAuth();
  if (!contextoSemTenantComLinhaDeServico(contexto, LINHAS_DE_SERVICO_QUE_EXIGEM_TENANT)) return null;

  return (
    <div className="tenant-warning">
      <span>Não foi possível localizar seu tenant Microsoft para serviços CSP. Favor entrar em contato com nosso suporte.</span>
    </div>
  )
}
